/* eslint-disable max-len */
export default {
  header: '',
  item: `<label class="{{cssClasses.label}}">
  <input type="radio" class="{{cssClasses.radio}}" name="{{attributeName}}" {{#isRefined}}checked{{/isRefined}} />{{label}}
</label>`,
  footer: '',
};



// WEBPACK FOOTER //
// ./src/widgets/numeric-refinement-list/defaultTemplates.js